<template>
    <div>
        <div v-if="dataInitializing && componentInitializing">
            <h3 class="primary--text mb-2">Loading order ...</h3>
            <v-progress-linear height="10"
                               color="primary"
                               rounded
                               indeterminate></v-progress-linear>
        </div>
        <div v-if="!dataInitializing">
            <!-- TODO: Add the application drop-down -->
            <psi-page-title :title="$_.get(currentScreen, 'applicant.name', '')"
                            :icon="page.icon"
                            :breadcrumbs="breadcrumbs"
                            @breadcrumbs-item-selected="breadCrumbItemSelected"
                            v-show="!dataInitializing && !componentInitializing">
                <template #actions>
                    <v-icon large
                            color="primary"
                            class="mt-3 mr-4">
                        mdi-tag
                    </v-icon>
                    <span class="text-subtitle-1 mt-3 primary--text">
                        {{ $_.get(currentScreen, "products[0].name", "") }}
                    </span>
                    <v-chip label
                            small
                            v-if="
                                $_.get(currentScreen, 'products[0].instant', false)
                            "
                            color="secondary"
                            class="text-uppercase mt-3 ml-3 pa-3">
                        <v-icon small
                                left> mdi-flash </v-icon>
                        Instant
                    </v-chip>
                </template>
            </psi-page-title>
            <order-test-toolbar v-show="!dataInitializing && !componentInitializing"></order-test-toolbar>
            <!-- Content always starts with a v-card  -->
            <v-card class="mt-4 px-3 py-5"
                    v-show="!dataInitializing && !componentInitializing">
                <!-- TODO: generate alerts from backend , alert here if we have alerts -->
                <screening-process-alert :alerts="$_.get(currentScreen, 'screen.alerts', [])">
                </screening-process-alert>
                <!-- Toolbar is sticky on scroll, uses the vuex store to get current screen -->
                <!-- TODO: Retrieve the menu options from the toolbar -->
                <screening-process-toolbar show-progress
                                           :progress="progress"
                                           :quickLinkItems="items"
                                           :title="currentScreen.applicant.type"
                                           :status-items="statusItems"
                                           :notification-items="notificationItems"
                                           :menu-items="menuItems"
                                           @quicklink:click="scrollTo($event)"
                                           @action="handleToolbarAction($event)"></screening-process-toolbar>
                <v-row>
                    <v-col cols="10">
                        <v-window v-model="window"
                                  class="elevation-1"
                                  vertical>
                            <v-window-item v-for="(category, index) in categories"
                                           :key="`category=${index}`"
                                           :value="category.id">
                                <screening-process-blocks @init="componentInitializing = false"
                                                          :current-screen="currentScreen"
                                                          :items="
                                                              items.filter((item) =>
                                                                  item.category
                                                                      ? item.category === category.id
                                                                      : false
                                                              )
                                                          ">
                                </screening-process-blocks>
                            </v-window-item>
                        </v-window>
                    </v-col>
                    <v-col cols="2"
                           class="py-6">
                        <psi-scroll-nav :items="categories"
                                        scroll-off
                                        :offset-height="150"
                                        :selected.sync="window" />
                    </v-col>
                </v-row>
                <!-- Content, setup as a 3 col view but main content can span 2 cols -->
            </v-card>
        </div>
        <screening-process-actions ref="screenProcessActions"
                                   :current-screen="currentScreen"
                                   :items="items"
                                   :selected-item-id="$config('screen.selectedNavItemId')" />
    </div>
</template>
<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

import HomeLink from '@/mixins/homelink';
import OrderTestToolbar from '@components/screen/components/OrderTestToolbar';
import ScreeningProcessAlert
    from '@components/screen/components/ScreeningProcessAlert';
import ScreeningProcessToolbar
    from '@components/screen/components/ScreeningProcessToolbar';

export default {
    name: "screening-process",
    mixins: [HomeLink],
    components: {
        ScreeningProcessToolbar,
        ScreeningProcessAlert,
        OrderTestToolbar,
        ScreeningProcessActions: () =>
            import("@components/screen/components/ScreeningProcessActions"),
        ScreeningProcessBlocks: () =>
            import("@components/screen/components/ScreeningProcessBlocks"),
    },
    data() {
        return {
            componentInitializing: true,
            page: {
                title: "",
                icon: "mdi-clipboard-account",
            },
            window: "processsing",
            blockId: "",

            breadcrumbs: [
                {
                    text: "Home",
                    disabled: false,
                },
                {
                    text: "Order History",
                    disabled: false,
                    to: { name: "Order History" },
                },
                {
                    options: {
                        text: "text",
                        value: "value",
                        width: 250,
                        selected: null,
                        items: [],
                    },
                },
                {
                    text: "Screening Processing",
                    disabled: true,
                },
            ],
        };
    },
    computed: {
        ...mapGetters("Screens", [
            "currentScreen",
            "currentApplication",
            "loading",
        ]),
        dataInitializing() {
            return (
                this.loading ||
                Object.keys(this.currentScreen).length === 0 ||
                Object.keys(this.currentApplication).length === 0
            );
        },
        items() {
            const navItems = this.$config("screen.navItems")
                .filter((item) => item.visible)
                .filter((item) => item.roles.includes(this.authUser.role_name))
                .reduce((prev, curr) => {
                    prev[curr.id] = curr;
                    return prev;
                }, {});

            // TODO: determine layout from screen,order
            const layout = this.getLayout(this.currentScreen);
            // We don't have a layout established yet
            if (!layout) {
                return [];
            }


            // Pass the Block Keys in props from the screen
            const keys = this.currentScreen.blockKeys.map((key) => {
                return {
                    id: key,
                    layout: "main",
                };
            });

            const items = keys
                .filter((key) => this.$_.has(navItems, key.id))
                .map((key) => {
                    return {
                        ...navItems[key.id],
                        layout: key.layout,
                    };
                });

            return items.sort((a, b) => a.order > b.order);
        },
        categories() {
            return this.$config("screen.categories").filter((category) => {
                return (
                    this.items.findIndex(
                        (item) => item.category === category.id
                    ) !== -1
                );
            });
        },
        progress() {
            return {
                value: this.$_.get(this.currentScreen, "screen.progress", 0),
                width: "250",
            };
        },
        menuItems() {
            return this.$config("screen.processToolBarItems");
        },
        notificationItems() {
            return [
                {
                    content: this.$_.get(
                        this.currentScreen,
                        "screen.notifications",
                        []
                    ).length,
                    color: "info",
                    class: "mr-4 hidden-sm-and-down",
                    eventName: "quicklink:click",
                    event: { id: "screening-notifications" },
                    icon: "mdi-bell",
                },
            ];
        },
        statusItems: {
            immediate: true,
            get() {
                let items = [
                    {
                        color: this.currentScreen.status.color,
                        class: "mr-4 d-none d-lg-block",
                        label: this.currentScreen.status.label,
                    },
                ];
                if (
                    this.currentScreen.status != "Completed" &&
                    this.$_.has(this.currentScreen, "screen.time_pending")
                ) {
                    items.push({
                        color: "error",
                        class: "d-none d-lg-block",
                        label: this.currentScreen.screen.time_pending,
                    });
                }
                return items;
            },
        },
    },
    methods: {
        ...mapActions("Screens", ["getCurrentScreen", "dataLoading"]),

        scrollTo(event) {
            const targetWindow = this.items.find(
                (item) => item.id === event.id
            ).category;

            if (targetWindow === this.window) {
                this.$vuetify.goTo(`#${event.id}`, {
                    easing: "easeInOutCubic",
                    offset: 100,
                    duration: 400,
                });
            } else {
                this.window = targetWindow;

                setTimeout(() => {
                    if (document.getElementById(event.id)) {
                        this.$vuetify.goTo(`#${event.id}`, {
                            easing: "easeInOutCubic",
                            offset: 100,
                            duration: 400,
                        });
                    }
                }, 350);
            }
        },
        applicationBreadCrumbItems() {
            const currentApplicantId = this.currentScreen.applicant.id;

            const items = this.currentApplication.applicants.map((item) => {
                return {
                    value: item.id,
                    text: `${item.type} - ${item.name}`,
                    disabled: item.id === currentApplicantId,
                };
            });
            return items;
        },
        breadCrumbItemSelected(item) {
            const applicant = this.currentApplication.applicants.find((val) => {
                return val.id == item.value;
            });
            this.$router.push({
                name: "Application Process",
                params: { id: applicant.screen.order_id },
            });
        },
        handleToolbarAction(action) {
            this.$refs.screenProcessActions.handleToolbarAction(action);
        },
        getLayout(screen) {
            // check applicant first since screen layouts fail without a screen
            if (
                this.$_.get(screen, "screen", {}) === null ||
                Object.keys(this.$_.get(screen, "screen", {})).length === 0
            ) {
                return null;
            }
            // Check RW first, it's instant but special case
            if (this.$_.get(screen, "products[0].name", "") === "Rent Well") {
                return "student";
            }
            if (this.$_.get(screen, "products[0].instant", false)) {
                return "instant";
            }
            return "full";
        },
        pick(object, keys) {
            return keys.reduce((obj, key) => {
                // eslint-disable-next-line no-prototype-builtins
                if (object && object.hasOwnProperty(key)) {
                    obj[key] = object[key];
                }
                return obj;
            }, {});
        },
    },
    watch: {
        $route: {
            immediate: true,
            deep: true,
            handler(to) {
                this.getCurrentScreen(to.params.id);
            },
        },
        currentApplication: {
            immediate: true,
            handler(val) {
                if (this.$_.has(val, "applicants")) {
                    const index = this.breadcrumbs.findIndex((item) =>
                        this.$_.has(item, "options")
                    );
                    this.breadcrumbs[index].options.selected =
                        this.currentScreen.applicant.id;
                    this.breadcrumbs[index].options.items =
                        this.applicationBreadCrumbItems();
                }
            },
        },
        homeUrl: {
            immediate: true,
            handler(homeUrl) {
                const index = this.breadcrumbs.findIndex(
                    (item) => item.text === "Home"
                );
                this.breadcrumbs.splice(
                    index,
                    1,
                    Object.assign(this.breadcrumbs[index], homeUrl)
                );
            },
        },
    },
    created() { },
};
</script>


<style scoped>
.fixed-toolbar {
    position: -webkit-sticky;
    position: sticky;
    top: 4.1rem;
    z-index: 2;
}
</style>